export default __webpack_public_path__ + "static/icon-2bcac125e98ce12d049068fdd21ac0cb.png";